type SeatInclusionCopyOptions = {
  nounSingular?: string;
  nounPlural?: string;
  includeIncludedWord?: boolean;
};

type PlanMarketing = {
  seatInclusions?: number | "Unlimited";
  storyInclusions?: number;
};

type PlanLike = {
  marketing?: PlanMarketing;
};

type PlanInclusionCopy = {
  seatCopy?: string;
  storyCopy?: string;
};

export function formatSeatInclusions(
  seatInclusions: number | string | undefined,
  options: SeatInclusionCopyOptions = {}
): string | undefined {
  if (!seatInclusions) {
    return undefined;
  }

  const { nounSingular = "member", nounPlural = "members", includeIncludedWord = true } = options;

  const noun = typeof seatInclusions === "number" && seatInclusions === 1 ? nounSingular : nounPlural;

  const includedSuffix = includeIncludedWord ? " included" : "";

  return `${seatInclusions} ${noun}${includedSuffix}`;
}

type StoryInclusionCopyOptions = {
  descriptor?: string;
};

export function formatStoryInclusions(storyInclusions: number, options?: StoryInclusionCopyOptions): string;
export function formatStoryInclusions(
  storyInclusions: number | undefined,
  options: StoryInclusionCopyOptions = {}
): string | undefined {
  if (typeof storyInclusions !== "number") {
    return undefined;
  }

  const { descriptor = "new published" } = options;
  const storyNoun = storyInclusions === 1 ? "story" : "stories";

  return `${storyInclusions} ${descriptor} ${storyNoun} each year`;
}

export function getPlanInclusionCopy(
  plan: PlanLike,
  seatOptions?: SeatInclusionCopyOptions,
  storyOptions?: StoryInclusionCopyOptions
): PlanInclusionCopy {
  const marketing = plan.marketing ?? {};

  return {
    seatCopy: formatSeatInclusions(marketing.seatInclusions, seatOptions),
    storyCopy: formatStoryInclusions(marketing.storyInclusions, storyOptions),
  };
}
